import axios from "axios";

import { getToken, clearSession } from "auth/storage";

if (!process.env.REACT_APP_API_URL) {
  throw new Error("REACT_APP_API_URL is not set. Create a .env file (see .env.example).");
}

// The single axios instance — the sole HTTP layer for the app.
const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});

// Request: attach the bearer token when present.
client.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response: on 401 clear the session and bounce to login; always surface a
// clean `normalizedMessage` callers can show in a snackbar.
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearSession();
      if (window.location.pathname !== "/authentication") {
        window.location.assign("/authentication");
      }
    }
    const normalizedMessage = error.response?.data?.message || error.message || "Request failed";
    return Promise.reject(Object.assign(error, { normalizedMessage }));
  }
);

export default client;
